// eslint-disable-next-line
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
// eslint-disable-next-line
import axios from "axios";
import { useSnackbar } from "notistack";
// eslint-disable-next-line
import React, { useState , useEffect} from "react";
// eslint-disable-next-line
import { config } from "../App";
//import ipConfig from "../ipConfig.json";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
// eslint-disable-next-line
import { useHistory, Link } from "react-router-dom";

const Register = (props) => {
// eslint-disable-next-line 
  const [username, setusername] = useState("");
  // eslint-disable-next-line 
  const [password, setpassword] = useState("");
  const [confirmPassword, setconfirm] = useState("");
  const [loading, setloading] = useState(false);
  //const [user, setUser] = useState()

  const handleusername = (e) => {
    setusername(e.target.value);
  };

  const handlepassword = (e) => {
    setpassword(e.target.value);
  };

  const handleconfirmpass = (e) => {
    setconfirm(e.target.value)
  }

/*   useEffect(() => {
  // storing input username & password
  localStorage.setItem("username", JSON.stringify(username));
}, [username]);

  useEffect(() => {
  // storing input username & password
  localStorage.setItem("password", JSON.stringify(password));
}, [password]);
 */
  // eslint-disable-next-line
  const { enqueueSnackbar } = useSnackbar();

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const formData = {
    "username": username,
    "password": password,
    "confirmPassword" : confirmPassword
  }

  // eslint-disable-next-line
  const register = async () => {
    const user = {
      username : formData.username,
      password : formData.password
    }
    try{
      setloading(true)
      const res = await axios
      .post(`${config.endpoint}/auth/register`,user)
      if(res.data.success)
      {
        enqueueSnackbar("success", {variant : 'success'})
        setloading(false)
         // store the user in localStorage
         window.localStorage.setItem('user', res.data)
         console.log(res.data)
      }
    }
    catch(error){
      if(error.response){
        enqueueSnackbar("Username is already taken", {variant : "error"});
        console.log(error)
      }
      else{
        enqueueSnackbar("Error :" + error.message, {variant : "error"})
      }
    }
  }
  

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  // eslint-disable-next-line
  const validateInput = () => {
    if (formData.username === "") {
      enqueueSnackbar("Username is a required field");
      return false;
    }
    else if (formData.password === "" || formData.confirmPassword === "") {
      enqueueSnackbar("Password is a required field");
      return false;
    }
    else if (formData.password.length < 6) {
      enqueueSnackbar("Password must be at least 6 characters");
      return false;
    }
    else if (formData.username.length < 6) {
      enqueueSnackbar("Username must be at least 6 characters");
      return false;
    }
    else if(formData.password !== formData.confirmPassword){
      enqueueSnackbar("do not match");
      return false;
    }
    else
    {
      register();
      return true;
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true}/>
      <Box className="content" style={{padding:30}}>
        <Stack spacing={2} style={{marginLeft:1000, marginRight:100, padding:30}}className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            onChange = {handleusername}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange = {handlepassword}
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            onChange = {handleconfirmpass}
            fullWidth
          />
           {loading ? <CircularProgress color="success" /> : <Link to='/login'><Button onClick={validateInput} variant="contained">
            Register Now
           </Button></Link>}
          <p className="secondary-action">
            Already have an account?{" "}
             <Link to='/login' className="link">
              Login here
             </Link> 
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
}

export default Register;
